"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MapSolid: function() {
        return MapSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const MapSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M8 5.27665L2.51156 2.1404C2.433 2.09355 2.34747 2.05718 2.2569 2.03319C2.1385 2.00166 2.01707 1.99281 1.89848 2.00503C1.75369 2.01966 1.61802 2.06517 1.49816 2.13487C1.37817 2.20436 1.27134 2.29958 1.18681 2.41804C1.11736 2.51493 1.0648 2.62476 1.03343 2.7432C1.00933 2.83373 0.998478 2.92604 1.00017 3.01749V16.9805C0.99942 17.0211 1.00114 17.0615 1.00528 17.1016C1.0199 17.2464 1.06541 17.3821 1.13512 17.5019C1.2046 17.6219 1.29982 17.7288 1.41828 17.8133C1.45106 17.8368 1.48532 17.8583 1.52089 17.8778L8 21.5802V5.27665Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M10 21.5352V5.13152L14 2.46486V18.8686L10 21.5352Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M16 18.723L21.4888 21.8595C21.5674 21.9063 21.6529 21.9427 21.7434 21.9667C21.8619 21.9982 21.9835 22.0071 22.1022 21.9948C22.2468 21.9801 22.3824 21.9346 22.5022 21.865C22.6222 21.7955 22.729 21.7003 22.8135 21.5819C22.883 21.485 22.9355 21.3751 22.9669 21.2567C22.991 21.1661 23.0019 21.0738 23.0002 20.9824V7.01934C23.0009 6.97877 22.9992 6.9383 22.9951 6.89815C22.9804 6.75339 22.9349 6.61775 22.8652 6.49792C22.7957 6.37786 22.7004 6.27098 22.5819 6.18643C22.5492 6.163 22.515 6.14149 22.4795 6.12207L16 2.41951V18.723Z",
            fill: "currentColor"
        })
    ]
}), "MapSolid");
const _default = MapSolid;
